export const selectScheduleActivityDetails = (state) =>
  state.classEntityReducer.scheduleSessionActivityData
